"use strict";

angular.module("admin")
	.controller("AdminExportMonitoringCtrl", ["exportTemplateDetail", "$scope", "$interval", "$route", "$q", "AdminClientsService", "OpenExportsService", "AdminExportTemplatesService", "$log",
		function (exportTemplateDetail, $scope, $interval, $route, $q, AdminClientsService, OpenExportsService, AdminExportTemplatesService, $log) {
		const vm = this;
		vm.data = {
			exportTemplateId: $route.current.params.id,
			exportTemplateName: "",
			displayExportFileToConsumer: true,
			isNetexExport: false,
			referentialId: -1,
			monitoringToDisplay: [],
			chouetteJobsId: new Set(),
			jobsEvents: new Map(),
			jobsSteps: new Map(),
		};

		if (exportTemplateDetail.status === 200) {
			vm.data.exportTemplateName = exportTemplateDetail.data.name;
			vm.data.displayExportFileToConsumer = exportTemplateDetail.data.consumers.length > 0;
			vm.data.isNetexExport = exportTemplateDetail.data.type === "NETEX";
			vm.data.exportedFileName = exportTemplateDetail.data.exportedFileName;
		}

		vm.clearData = function () {
			vm.data.chouetteJobsId = new Set();
			vm.data.jobsEvents = new Map();
			vm.data.jobsSteps = new Map();
		};

		vm.addItemInOrder = function(monitoring) {
			let items = vm.data.monitoringToDisplay;
			let index = items.findIndex(item => item.jobId <= monitoring.jobId);
			if (index === -1) {
				items.push(monitoring);
			} else {
				items.splice(index, 0, monitoring);
			}
		};

		vm.mapDate = function(timestamp) {
			const date = new Date(timestamp);
			return date.toLocaleString("fr-FR");
		};

		vm.findExportFileToConsumerEvent = function(jobId) {
			let result = null;
			if (vm.data.jobsEvents.has(jobId)) {
				let targetJob = vm.data.jobsEvents.get(jobId).find(event => event.action === "EXPORT_TO_CONSUMER");
				if (targetJob) {
					if (targetJob.description) {
						result = [];
						const exportsFileInfo = targetJob.description.split(";");
						if (angular.isArray(exportsFileInfo)) {
							exportsFileInfo.forEach(consumer => {
								const info = consumer.split(",");
								if (angular.isArray(info) && info.length === 3) {
									result.push({type:info[0], state: info[1], name: info[2]});
								}
							});
						}
					} else {
						result = [{type:"Dépôt", state: targetJob.state}];
					}
				}
			}
			return result;
		};

		vm.mapGlobalExportReponse = function (rawData) {
			rawData.forEach(item => {
				if (angular.isArray(item.events) && item.events) {
					let targetEvent = item.events.find(event => event.chouetteJobId !== null && event.chouetteJobId !== undefined);
					if (targetEvent) {
						let jobid = targetEvent.chouetteJobId;
						vm.data.jobsEvents.set(jobid, item.events);
					}
				}

			});
		};

		vm.mapGlobalExportSteps = function (rawData) {
			if (angular.isArray(rawData) && rawData.length) {
				rawData.forEach(item => {
					const chouetteJobId = item.jobId;
					if (!vm.data.chouetteJobsId.has(chouetteJobId)) {
						vm.data.chouetteJobsId.add(chouetteJobId);
					}
					if (vm.data.jobsSteps.has(chouetteJobId)) {
						const jobSteps = vm.data.jobsSteps.get(chouetteJobId);
						jobSteps.push(item);
					} else {
						const jobSteps = [];
						jobSteps.push(item);
						vm.data.jobsSteps.set(chouetteJobId, jobSteps);
					}
				});
			}
		};

		vm.buildMonitoringDetailToDisplay = function(jobId) {
			let result = [];
			if (vm.data.jobsSteps.has(jobId)) {
				result = vm.data.jobsSteps.get(jobId);
			}
			return result;
		};

		vm.buildMonitoringToDisplay = function (jobDetail) {
			const jobId = jobDetail.id;
			const startDate = vm.mapDate(jobDetail.started);
			const globalStatus = jobDetail.status;
			const generatedFile = vm.data.isNetexExport ? "global_netex.zip" : "gtfz.zip";
			const depositeState = vm.findExportFileToConsumerEvent(jobId);
			let deposite = generatedFile ? vm.data.exportedFileName : "";
			return {
				jobId,
				startDate,
				globalStatus,
				generatedFile,
				deposite,
				depositeState,
				details: vm.buildMonitoringDetailToDisplay(jobId)
			};
		};

		vm.downloadFile = function(monitoring) {
			OpenExportsService.getOfferExportFile(vm.data.referentialId, monitoring.jobId)
				.then((response) => {
					let blob = new Blob([response.data], {type: "octet/stream"});
					let a = document.createElement("a");
					a.href = (window.URL || window.webkitURL).createObjectURL(blob);
					a.target = "_blank";
					a.download = monitoring.generatedFile;
					document.body.appendChild(a);
					a.click();
				}).catch(function () {
					$log.error("Le fichier est introuvable sur le serveur.", "Problème lors du téléchargement");
				});
		};

		vm.keepLatestJobs = function() {
			const jobIds = Array.from(vm.data.chouetteJobsId);
			jobIds.sort((a, b) => b - a);
			const sliceIndex = Math.min(jobIds.length, 20);
			return jobIds.splice(0, sliceIndex);
		};

		vm.fetchData = function() {
			const actionFilter = ["EXPORT_TO_CONSUMER"];
			if (vm.data.isNetexExport) {
				actionFilter.push("EXPORT_NETEX_MERGED");
			} else {
				actionFilter.push("EXPORT_GTFS_MERGED");
			}
			let promises = [
				OpenExportsService.getAllGlobalExports(vm.data.referentialId, actionFilter),
				AdminExportTemplatesService.getAllByTemplateId($route.current.params.id)
			];

			$q.all(promises).then((responses)=> {
				vm.clearData();
				const globalExportEventsResponse = responses[0];
				const globalExportsStepsResponse = responses[1];
				if (globalExportEventsResponse.status === 200 && globalExportsStepsResponse.status === 200) {
					vm.mapGlobalExportReponse(globalExportEventsResponse.data);
					vm.mapGlobalExportSteps(globalExportsStepsResponse.data);
					if (vm.data.chouetteJobsId.size) {
						const latestJobs = vm.keepLatestJobs();
						vm.data.monitoringToDisplay = [];
						latestJobs.forEach(jobId => {
							OpenExportsService.getChouetteJobDetail("mobiiti_technique", jobId).then(response => {
								if (response.status === 200) {
									vm.addItemInOrder(vm.buildMonitoringToDisplay(response.data));
								}
							});
						});
					}
				}
			});
		};

		AdminClientsService.getReferentialId().then(data => {
			if (data) {
				vm.data.referentialId = data;

				vm.fetchData();

				vm.data.pollingReference = $interval(vm.fetchData, 10000);
			}

		});

		$scope.$on("$destroy", () => {
			if (vm.data.pollingReference) {
				$interval.cancel(vm.data.pollingReference);
			}
		});

	}]);